<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="4" class="m-t-5px p-a-0">
                        <multiselect v-model="cliente"
                        :options-limit="300"
                        :limit="10"
                        :limit-text="limitText"
                        :options="optionsCliente"
                        track-by="value"
                        label="label"
                        id="cliente"
                        :hide-selected="true"
                        placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        :searchable="true"
                        :loading="isLoadingCliente"
                        @search-change="listaClientesPessoa"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                     <b-form-datepicker
                        locale="pt-br"
                        reset-button  
                        placeholder="Data Inicial" 
                        v-model="dt_emissao_ini" 
                        class="form-control" 
                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                     <b-form-datepicker
                        locale="pt-br" 
                        reset-button 
                        placeholder="Data Inicial" 
                        v-model="dt_emissao_fim" 
                        class="form-control" 
                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="tp_doc"
                        :options="this.$parent.tpDocOptions"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo de documento"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                      <div class="input-group-btn">
                        <div class="btn-group">
                          <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                          <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                        </div>
                      </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import { formatCNPJFromParts } from "../utils";

import moment from 'moment'
export default {
  data () {
    return {
    cliente: [],
    isLoadingCliente:false,
    optionsCliente: [],
    dt_emissao_ini: '',
    dt_emissao_fim: '',
    tp_doc: [],
    data_filter: [],
    helpForm: new Form({statusRecord: [], params: [], search: "",}),
    }
  },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {
            cliente: this.cliente,
            dt_emissao_ini: this.formatDateSubmit(this.dt_emissao_ini),
            dt_emissao_fim: this.formatDateSubmit(this.dt_emissao_fim),
            tp_doc: this.tp_doc,}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cliente='',
        this.dt_emissao_ini='',
        this.dt_emissao_fim='',
        this.tp_doc='',
        this.$events.fire('filter-reset');
      },
      formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
          return (value == null || value == "")
            ? ''
            : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
      },
      listaClientesPessoa(search) {
        if(search.length>=3)
        {
            this.isLoadingCliente = true;
            this.helpForm.search = search;
            this.helpForm.status = 1;
            this.helpForm.post('/api/pessoa/jsonlist/cliente').then(response =>
            {
                this.optionsCliente = [];
                new ReturnApi(response, this, true, false, false);
                if(response.items.length>0)
                {
                    response.items.forEach((obj)=>
                    {
                        this.optionsCliente.push({nome: obj.razao_social, cpf: null, cnpj: this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito).replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/, "$1.$2.$3/$4-$5"), ie: obj.inscricao_estadual, endereco: obj.pessoa.pessoa_endereco[0].endereco, municipio: obj.pessoa.pessoa_endereco[0].municipio.nome, uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,  label: "PJ -"+obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, pessoa_id: obj.pessoa_id, value: obj.pessoa_id })
                    });
                }
                if(response.itemsF.length>0) {
                    response.itemsF.forEach((obj)=>
                    {
                        this.optionsCliente.push({nome: obj.nome, cpf: obj.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"), cnpj: null, ie: null, endereco: obj.pessoa.pessoa_endereco[0].endereco, municipio: obj.pessoa.pessoa_endereco[0].municipio.nome, uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,  label: "PF -"+obj.nome+" - "+obj.cpf, pessoa_id: obj.pessoa_id, value: obj.pessoa_id })
                    });
                }
                if(response.itemsE.length>0)
                {
                    response.itemsE.forEach((obj)=>
                    {
                        this.optionsCliente.push({nome: obj.nome, cpf: null, cnpj: obj.cuit, ie: null, endereco: obj.pessoa.pessoa_endereco[0].endereco, municipio: obj.pessoa.pessoa_endereco[0].municipio.nome, uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,   label: "PE -"+obj.nome+" - "+obj.cd, pessoa_id: obj.pessoa_id, value: obj.pessoa_id })
                    });
                }
                this.isLoadingCliente = false;
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
              });
            }
      },
            onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
      },
    limitText (count) {
        return ' e ${count} outros clientes'
    },
  },
  computed: {
      vuetableFilterButton: {
          get () {
              return this.$store.state.vuetable.filterButton;
          },
      },
  }
}
</script>